/// <reference types="vite/client" />

export async function downloadRequest(items: [], email?: string): Promise<any> {
    const env: any = import.meta.env;
    const url = `${env.VITE_API_URL}/digital_objects/trigger_download`;
    const options = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            codeList: items.map((item: any) => item.identifier),
            email: email || '',
        })
    };
    console.log('Fetching download request with the following parameters on ', url);
    console.table(options);
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data.status === 'queued') {
            if (data.downloadRequestCode) {
                console.log('Download request code received:', data.downloadRequestCode);
                return { code: data.downloadRequestCode, wouldEmail: email ? true : false, success: true, result: data.result || null, expected: data.expectedFiles || null };
            } else {
                console.warn('No download request code received, check the API response');
                return { success: false, message: 'No download request code received from the API.' };
            }
        } else {
            console.warn('Download request was not queued, check the API response');
            return { success: false, message: 'Download request was not queued.' };
        }
    } catch (error: any) {
        console.error(error);
        return { success: false }
    }

    //generate a unique code for the download containing numbers and capital letters



}

export async function checkDOAvailability(identifier: any): Promise<any> {
    const env: any = import.meta.env;
    const url = `${env.VITE_API_URL}/digital_objects/digital_objects_availability`;
    const options = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(
            [identifier]
        )
    }
    console.log('The API will call to ', url, options);
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;

    } catch (error: any) {
        console.error('Error in checkDOAvailability', error);
        return { status: 'error', message: error.message || 'An error occurred while checking availability.' };
    }
}

export async function getDownloadStatus(requestCode: string) {
    const env: any = import.meta.env;
    const url = `${env.VITE_API_URL}/digital_objects/download_status/${requestCode}`;
    const options = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };
    console.log('Fetching download status from ', url);
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Download status received:', data);
        return data;
    }
    catch (error: any) {
        console.error('Error fetching download status:', error);
        return { success: false, message: error.message || 'An error occurred while fetching download status.' };
    }

}

